import { render, staticRenderFns } from "./PickupWay.vue?vue&type=template&id=2ef7b114&scoped=true&"
import script from "./PickupWay.vue?vue&type=script&lang=js&"
export * from "./PickupWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef7b114",
  null
  
)

export default component.exports